/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppProtectionsQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']['input'];
  productTypes?: Types.InputMaybe<Array<Types.AppProductTypeEnum> | Types.AppProductTypeEnum>;
  certificationTypes?: Types.InputMaybe<Array<Types.AppCertificationTypeEnum> | Types.AppCertificationTypeEnum>;
  statuses?: Types.InputMaybe<Array<Types.AppProtectionStatusEnum> | Types.AppProtectionStatusEnum>;
}>;

export type IAppProtectionsQuery = {
  __typename?: 'Query';
  appProtections: Array<
    | {
        __typename?: 'Backup';
        id: string;
        certificationValidated: boolean;
        certificationVerified: boolean;
        name: string;
        lastBackup?: any | null;
        productType: Types.AppProductTypeEnum;
        backupStatus: Types.BackupStatusEnum;
        backupCreator?: { __typename?: 'User'; id: string; name?: string | null } | null;
        policy: { __typename?: 'BackupPolicy'; remove: boolean };
        taskCounts: Array<{ __typename?: 'TaskCount'; count: number; criticality: Types.TaskCriticalityEnum }>;
      }
    | {
        __typename?: 'ContinuityEscrow';
        id: string;
        certificationValidated: boolean;
        certificationVerified: boolean;
        certificationCertified: boolean;
        lastProvider?: any | null;
        productType: Types.AppProductTypeEnum;
        escrowStatus: Types.EscrowStatusEnum;
        depositor?: { __typename?: 'Depositor'; id: string; companyName?: string | null } | null;
        beneficiary?: {
          __typename?: 'Beneficiary';
          id: string;
          companyName?: string | null;
          companyWebsite?: string | null;
        } | null;
        agreement: { __typename?: 'Agreement'; id: string; agreementForm?: Types.AgreementFormEnum | null };
        escrowInvitation?: { __typename?: 'EscrowInvitation'; id: string; status: Types.InvitationStatusEnum } | null;
        policy: { __typename?: 'ContinuityEscrowPolicy'; remove: boolean };
        taskCounts: Array<{ __typename?: 'TaskCount'; count: number; criticality: Types.TaskCriticalityEnum }>;
      }
    | {
        __typename?: 'CustodianProfile';
        id: string;
        activatedAt?: any | null;
        certificationValidated: boolean;
        name: string;
        productType: Types.AppProductTypeEnum;
        custodianStatus: Types.CustodianProfileStatusEnum;
        custodianCreator?: { __typename?: 'User'; id: string; name?: string | null } | null;
        policy: { __typename?: 'CustodianProfilePolicy'; remove: boolean };
        taskCounts: Array<{ __typename?: 'TaskCount'; count: number; criticality: Types.TaskCriticalityEnum }>;
      }
    | {
        __typename?: 'SaasEscrow';
        id: string;
        certificationValidated: boolean;
        certificationVerified: boolean;
        certificationCertified: boolean;
        lastDeposit?: any | null;
        productType: Types.AppProductTypeEnum;
        escrowStatus: Types.EscrowStatusEnum;
        depositor?: { __typename?: 'Depositor'; id: string; companyName?: string | null } | null;
        beneficiary?: {
          __typename?: 'Beneficiary';
          id: string;
          companyName?: string | null;
          companyWebsite?: string | null;
        } | null;
        agreement: { __typename?: 'Agreement'; id: string; agreementForm?: Types.AgreementFormEnum | null };
        escrowInvitation?: { __typename?: 'EscrowInvitation'; id: string; status: Types.InvitationStatusEnum } | null;
        policy: { __typename?: 'SoftwareEscrowPolicy'; remove: boolean };
        taskCounts: Array<{ __typename?: 'TaskCount'; count: number; criticality: Types.TaskCriticalityEnum }>;
      }
    | {
        __typename?: 'SoftwareEscrow';
        id: string;
        certificationValidated: boolean;
        certificationVerified: boolean;
        certificationCertified: boolean;
        lastDeposit?: any | null;
        productType: Types.AppProductTypeEnum;
        escrowStatus: Types.EscrowStatusEnum;
        depositor?: { __typename?: 'Depositor'; id: string; companyName?: string | null } | null;
        beneficiary?: {
          __typename?: 'Beneficiary';
          id: string;
          companyName?: string | null;
          companyWebsite?: string | null;
        } | null;
        agreement: { __typename?: 'Agreement'; id: string; agreementForm?: Types.AgreementFormEnum | null };
        escrowInvitation?: { __typename?: 'EscrowInvitation'; id: string; status: Types.InvitationStatusEnum } | null;
        policy: { __typename?: 'SoftwareEscrowPolicy'; remove: boolean };
        taskCounts: Array<{ __typename?: 'TaskCount'; count: number; criticality: Types.TaskCriticalityEnum }>;
      }
  >;
};

export const AppProtectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'appProtections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppProductTypeEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'certificationTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCertificationTypeEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'statuses' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppProtectionStatusEnum' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appProtections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'certificationTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'certificationTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statuses' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'statuses' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taskCounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Backup' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'backupStatus' },
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationValidated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastBackup' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'backupCreator' },
                        name: { kind: 'Name', value: 'creator' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ContinuityEscrow' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'escrowStatus' },
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationValidated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationCertified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastProvider' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'depositor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrowInvitation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustodianProfile' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'custodianStatus' },
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationValidated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'custodianCreator' },
                        name: { kind: 'Name', value: 'creator' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SaasEscrow' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'escrowStatus' },
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationValidated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationCertified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastDeposit' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'depositor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrowInvitation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SoftwareEscrow' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'escrowStatus' },
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationValidated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'certificationCertified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastDeposit' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'depositor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beneficiary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'escrowInvitation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppProtectionsQuery, IAppProtectionsQueryVariables>;
